import { render, staticRenderFns } from "./transportation.vue?vue&type=template&id=3f9b5a29&scoped=true&"
import script from "./transportation.vue?vue&type=script&lang=js&"
export * from "./transportation.vue?vue&type=script&lang=js&"
import style0 from "./transportation.vue?vue&type=style&index=0&id=3f9b5a29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9b5a29",
  null
  
)

export default component.exports